import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Gift, Sparkles } from 'lucide-react';
const bonuses = [{
  num: 'B1',
  title: 'Guía de Hábitos Poderosos',
  desc: 'Aprende cómo crear hábitos saludables que realmente duren.',
  image: 'https://images.unsplash.com/photo-1506784983877-45594efa4cbe?w=600&q=70&auto=format&fit=crop',
  alt: 'Agenda de hábitos diarios'
}, {
  num: 'B2',
  title: 'Planificador de Rutinas',
  desc: 'Organiza tus entrenamientos y mide tu progreso fácilmente.',
  image: 'https://images.unsplash.com/photo-1517836357463-d25dfeac3438?w=600&q=70&auto=format&fit=crop',
  alt: 'Planificador semanal de entrenamiento'
}, {
  num: 'B3',
  title: 'Mini Guía de Motivación Mental',
  desc: 'Técnicas prácticas para mantenerte enfocado y evitar abandonar.',
  image: 'https://images.unsplash.com/photo-1499209974431-9dddcece7f88?w=600&q=70&auto=format&fit=crop',
  alt: 'Persona motivada al amanecer'
}];
export function BonusGrid() {
  return <section className="py-20 px-4 bg-black relative" data-id="element-33">
      <div className="absolute inset-0 bg-brand/5 pointer-events-none" data-id="element-34" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-35">
        <div className="text-center mb-12" data-id="element-36">
          <div className="inline-flex items-center gap-2 bg-brand/20 text-brand px-4 py-2 rounded-full font-bold uppercase tracking-wider mb-6 text-sm" data-id="element-37">
            <Gift className="w-4 h-4" data-id="element-38" />
            INCLUIDOS GRATIS
          </div>
          <h2 className="text-5xl md:text-6xl font-display uppercase text-white mb-4" data-id="element-39">
            3 BONUS EXCLUSIVOS
          </h2>
          <p className="text-gray-400 text-base" data-id="element-40">
            Sumá estos recursos sin costo extra a tu compra hoy.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-10" data-id="element-41">
          {bonuses.map((bonus, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-dark-card border border-brand/30 rounded-xl overflow-hidden flex flex-row md:flex-col hover:border-brand transition-colors group" data-id="element-42">
              {/* Image — compact thumbnail */}
              <div className="relative w-28 md:w-full md:h-36 shrink-0 overflow-hidden bg-dark" data-id="element-43">
                <img src={bonus.image} alt={bonus.alt} loading="lazy" decoding="async" className="w-full h-full object-cover opacity-70 group-hover:opacity-90 group-hover:scale-105 transition-all duration-500" data-id="element-44" />
                <div className="absolute inset-0 bg-gradient-to-r md:bg-gradient-to-t from-dark-card via-dark-card/40 to-transparent" data-id="element-45" />
                <div className="absolute top-2 left-2 bg-brand text-white text-xs font-display tracking-wider px-2 py-0.5 rounded" data-id="element-46">
                  {bonus.num}
                </div>
              </div>

              {/* Content — tight padding */}
              <div className="p-4 flex-1 flex flex-col justify-center" data-id="element-47">
                <div className="flex items-center gap-1.5 text-brand text-[10px] font-bold uppercase tracking-widest mb-1" data-id="element-48">
                  <Sparkles className="w-3 h-3" data-id="element-49" />
                  Bonus Gratis
                </div>
                <h3 className="text-base md:text-lg font-bold text-white mb-1 leading-tight" data-id="element-50">
                  {bonus.title}
                </h3>
                <p className="text-gray-400 text-xs md:text-sm leading-snug" data-id="element-51">
                  {bonus.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-52">
          <p className="text-xl md:text-2xl font-display text-white uppercase tracking-wide bg-dark-card inline-block px-6 py-3 rounded-xl border border-dark-border" data-id="element-53">
            VALOR TOTAL:{' '}
            <span className="line-through text-gray-500" data-id="element-54">$20.000</span> —{' '}
            <span className="text-brand" data-id="element-55">HOY INCLUIDOS GRATIS</span>
          </p>
        </motion.div>
      </div>
    </section>;
}